import { ButtonGroup } from "react-bootstrap";
import Backdrop from "@mui/material/Backdrop";
import Button from "@mui/material/Button";

export default function CancelQuizPrompt(props) {
  return (
    <Backdrop
      sx={{
        color: "#fff",
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
      open={props.viewCancel}
    >
      <ButtonGroup
        id="ButtonGroup"
        variant="contained"
        className="selection-group"
        aria-label="outlined primary button group"
        style={{ display: "none" }}
      >
        <div className="quiz-text">Naozaj chceš test ukončiť predčasne?</div>
        <Button
          variant="contained"
          className="selection-button"
          onClick={() => {
            props.resetTest();
            props.historyPush("/");
          }}
        >
          Áno
        </Button>
        <Button
          variant="contained"
          className="selection-button"
          id="selection-button-red"
          onClick={() => {
            props.setViewCancel(false);
          }}
        >
          Nie
        </Button>
      </ButtonGroup>
    </Backdrop>
  );
}
